import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const StatsWrapper = styled.div`
	padding: 70px 0;
	display: flex;
	justify-content: center;
	.statsBlock {
		width: 145px;
		margin-left: 40px;
		margin-right: 40px;
		.statsHeading {
			font-size: 28px;
			font-weight: ${FONT_WT_MEDIUM};
			line-height: 1;
			text-align: center;
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
		.statsContent {
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			line-height: 1.38;
			text-align: center;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			margin-top: 10px;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP - 1}px) {
		padding: 60px 0px;
		.statsBlock {
			margin-left: 15px;
			margin-right: 15px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 30px 20px;
		flex-direction: column;
		.statsBlock {
			margin: auto;
			padding-bottom: 20px;
		}
	}
`;
